import React, { Component } from "react"
import {
    createPlanTextMeta,
    calculateNumberofTeamMembers,
} from "../util/billing_info_utils"

const BILLING_SETTINGS_PLAN_TEXT = "Plan"
const BILLING_SETTINGS_CANCEL_PLAN_BUTTON = "Cancel Plan"

class BillingSettingsPlan extends Component {
    constructor(props) {
        super(props)
    }

    renderMemberText = numberOfMembers => {
        if (numberOfMembers < 2) {
            return `${numberOfMembers} member`
        } else {
            return `${numberOfMembers} members`
        }
    }

    renderInvitationText = pendingMembers => {
        return pendingMembers === 1
            ? `, 1 pending invitation`
            : pendingMembers > 1
                ? `, ${pendingMembers} pending invitations`
                : ""
    }

    renderMemberAndInvitationText = (numberOfMembers, pendingMembers) => {
        return (
            this.renderMemberText(numberOfMembers) +
            this.renderInvitationText(pendingMembers)
        )
    }

    renderInfoPlanText = (planTextMeta, paymentStatus) => {
        const { name, price, user, period } = planTextMeta
        const pricePerInterval = `($${price}/${user}/${period})`

        const displayedPricePerInterval = paymentStatus === "cancelled"
            ? `${pricePerInterval} - Cancelled`
            : pricePerInterval

        return (
            <p>
                <span className="admin-billing-info-plan">{name} </span>
                {displayedPricePerInterval}
            </p>
        )
    }

    render() {
        const {
            teamMembers,
            // selectedTeamInvites,
            customer,
            customer: { paymentStatus },
            handleCancelPlan,
        } = this.props

        const numofTeamMembers = calculateNumberofTeamMembers(
            teamMembers,
        )
        
        // todo: get num of pending invites for all of users teams
        // const numOfPendingMembers = selectedTeamInvites.sort.length
        const numOfPendingMembers = 0

        const planTextMeta = createPlanTextMeta(customer)
        const renderedMemberText = this.renderMemberAndInvitationText(
            numofTeamMembers,
            numOfPendingMembers,
        )
        return (
            <div className="billing-settings-plan-container">
                <p className="billing-overview-section-title">
                    {BILLING_SETTINGS_PLAN_TEXT}
                </p>
                <div className="billing-settings-plan-meta">
                    {!!planTextMeta && this.renderInfoPlanText(planTextMeta, paymentStatus)}
                    <p>{renderedMemberText}</p>
                </div>
                {paymentStatus === "paid" ? (
                    <div className="cancel-button-container">
                        <button
                            onClick={handleCancelPlan}
                            className="btn btn-light billing-info-button"
                        >
                            {BILLING_SETTINGS_CANCEL_PLAN_BUTTON}
                        </button>
                    </div>
                ) : (
                    <div className="hide-button" />
                )}
            </div>
        )
    }
}

export default BillingSettingsPlan



// WEBPACK FOOTER //
// ./src/components/billing_settings_plan.jsx